import { typedQueryClient, useTypedMutation } from "hooks";
import { CheckInServicesQueryKeys } from "modules/CheckInServices/queryKeys";
import { ApiInstance } from "utils/Api";

export const useDeleteCheckInServiceMutation = () =>
  useTypedMutation<number, void>({
    mutationFn: id => ApiInstance.post("/check_in/service/delete", { id }),
    onSuccess: id => {
      const services = typedQueryClient.getQueryData(CheckInServicesQueryKeys.dealerList);
      if (!services) return;

      const serviceIdx = services.findIndex(service => service.id === id);
      if (serviceIdx === -1) return;

      typedQueryClient.setQueryData(CheckInServicesQueryKeys.dealerList, services.toSpliced(serviceIdx, 1));
    }
  });
